export default {
  ACCEPTED_FORMATS: ' (Accepted formats: JPEG, PNG, JPG)',
  ACTIONS: 'Actions',
  ACTIVE: 'Active',
  ADD: 'Add',
  ADD_PRODUCTS: 'Add Products',
  ADD_SUPPLIER: ' Add Supplier',
  ADDING_NEW_CATEGORY_DETAILS: 'Adding new Category Details...',
  ADDING_NEW_NOTE: 'Adding new Note...',
  ADDING_NEW_ORDER: 'Adding new Order ...',
  ADDING_PRODUCTS_TO_THE_DRAFT: 'Adding Products to the draft ...',
  ADDRESS: 'Address',
  APPLY: 'Apply',
  AUTHENTICATING: 'Authenticating...',

  BACK_ORDER: 'Backorder',
  BACK_ORDER_ID: 'Backorder ID',
  BAKEASY_STORE_PORTAL: 'Order-EZ Customer Portal',
  BASIC_DETAILS: 'Basic Details',
  BILL_DATE: 'Bill Date',

  CANCEL: 'Cancel',
  CATEGORY: 'Category',
  CHANGE_PASSWORD: 'Change Password',
  CHECK: 'Check',
  CITY: 'City',
  CLEAR: 'Clear',
  COMMENTS: 'Comments',
  COMPANY_ADDRESS: 'Company Address',
  COMPANY_NAME: 'Company Name',
  COMPOSE: 'Compose',
  CONFIRM_PASSWORD: 'Confirm Password',
  CONTACT_SUPPORT: 'Please contact System Technical Support',
  CONTENT: 'Content',
  COST_PRICE: 'Cost Price',
  COUNTRY: 'Country',
  CREATE: 'Create',
  CREATE_ORDER: 'Create Order',
  CREATED_DATE: 'Created Date',
  CURRENT_PASSWORD: 'Current Password',
  CUSTOMER: 'Customer',

  DATE_MM_DD_YYYY: 'Date',
  DATE_TO_BE_DELIVERED: 'Date to be Delivered',
  DELETE: 'Delete',
  DELETE_MESSAGE_CONFIRMATION: 'Are you sure you want to delete this message?',
  DELETING_MESSAGE: 'Deleting Message...',
  DELIVERY_DATE: 'Delivery Date',
  DESCRIPTION: 'Description',

  DOWNLOAD_SUCCESS: 'Download Success',
  DOWNLOADING_ORDERS: 'Downloading Orders...',
  DOWNLOADING_PRODUCT_DETAILS: 'Downloading Product Details...',
  DOWNLOADING_PRODUCTS: 'Downloading Products...',
  DUE_DATE: 'Due Date',
  DUPLICATE: 'Duplicate',

  EDIT: 'Edit',
  EMAIL: 'Email',
  EMAIL_ID: 'Email ID',
  ENTER: 'Enter ',
  ESTIMATED_SHIPPING_CHARGES: 'Estimated Shipping Charges',
  ESTIMATED_TAXES_1: 'Estimated Taxes 1',
  ESTIMATED_TAXES_2: 'Estimated Taxes 2',
  EXPECTED_DATE: 'Expected Date',
  EXPORT: 'Export',

  FETCHING_CATEGORIES: 'Fetching Categories...',
  FETCHING_CATEGORIES_DETAILS: 'Fetching Categories Details...',
  FETCHING_CREATE_ORDERS: 'Fetching create orders...',
  FETCHING_DRAFT_ORDER: 'Fetching Draft Order...',
  FETCHING_INVOICE_DETAILS: 'Fetching  Invoice Details...',
  FETCHING_INVOICES: 'Fetching Invoices...',
  FETCHING_MESSAGE_STATUS: 'Fetching Message Status...',
  FETCHING_MESSAGES: 'Fetching Messages...',
  FETCHING_NAMES: 'Fetching Names...',
  FETCHING_ORDERHISTORY_DETAILS: 'Fetching orderHistory  details...',
  FETCHING_PRODUCTS: 'Fetching Products...',
  FETCHING_REPLIES: 'Fetching Replies...',
  FETCHING_SHIPPINGS: 'Fetching Shipping...',
  FETCHING_SHIPPINGS_DETAILS: 'Fetching Shipping details...',
  FETCHING_STORES_DETAILS: 'Fetching Customers Details...',
  FETCHING_SUPPLIER_DETAILS: 'Fetching Supplier Details...',
  FETCHING_SUPPLIERS: 'Fetching Suppliers...',

  FILTER: 'Filter',
  FORGOT_PASSOWRD: 'Forgot Password?',
  FROM: 'From',

  GENERAL_PRODUCT_COST: 'General Product Cost',
  GENERATE: 'Generate',
  GETUSER_PROFILE: 'GetUser profile...',
  GoToOrderForm: 'Go Back to Order Form',
  GO_BACK_TO_ORDER_DETAILS: 'Go Back to Order Details',
  GO_BACK_TO_ORDER_FORM: 'Go back to order form',

  HIGH_PRIORITY: 'High Priority',
  IS_NOT_SAME: 'Is not the same',
  INACTIVE: 'Inactive',
  INGREDIENT_IMAGE: 'Ingredient Image',
  INGREDIENT_LABEL_IMAGE: 'Ingridient Label Image',
  INGREDIENT_NAME: 'Ingredient Name',
  INGREDIENTS: 'Ingredients',

  INVOICE__ID: 'InvoiceID',
  INVOICE_ID: 'Invoice ID',
  INVOICE_DATE: 'Invoice Date',
  INVOICE_FILTER: 'Invoice Filter',
  INVOICED_DATE: 'Invoiced Date',
  INVOICED_VALUE: 'Invoiced value',
  INVOICES: 'Invoices',
  IS_REQUIRED: 'is required',
  INVOICE_DETAILS: 'Invoice Details',

  LANGUAGE: 'Language',
  LOGOUT: 'Logout',

  MEASURE_PER_UNITS: 'Measure per Unit',
  MEASURE_TYPE: 'Measure Type',
  MEDIA_IMAGE: 'Media (Image)',
  MESSAGE_COMPOSE: 'Message Compose',
  MESSAGE_FILTERS: 'Message Filters',
  MESSAGES: 'Messages',
  MESSAGES_THREAD: 'Messages Thread',
  METHOD: 'Method',
  MOBILE: 'Mobile',
  MODIFYING_LANGUAGE: 'Modifying Language...',
  MODIFYING_PROFILE: 'Modifying profile...',

  NAME: 'Name',
  NEW: 'New',
  NEW_MESSAGE: 'New Message',
  NEW_ORDER_SUMMARY: 'New Order Summary',
  NEW_PASSWORD: 'New Password',
  NO: 'No',
  NO_DATA_FOUND: 'No Data Found',
  NO_SUBORDERS_PRESENT: 'No suborders present',
  NORMAL: 'Normal',
  NOT_APPLICABLE: 'Not Applicable',
  NOTE: 'Note',
  NOTE_CREATED_SUCCESSFULLY: 'Note Created successfully',
  NUTRITION_IMAGE: 'Nutrition Image',
  NUTRITION_LABEL_IMAGE: 'Nutrition Label Image',

  OK: 'Ok',
  ORDER_BY: 'Ordered By',
  ORDER_CANCEL_CONFIRM_MESSAGE:
    'Are you sure you want to cancel/delete this order?',
  ORDER_DATE: 'Order Date',
  ORDER_DETAILS: 'Order Details',
  ORDER_FORM: 'Order Form',
  ORDER_HISTORY: 'Order History',
  ORDER_HISTORY_FILTER: 'Order History Filter',
  ORDER_ID: 'Order ID',
  ORDER_INFO: 'Order Info',
  ORDER_STATUS: 'Order Status',
  ORDER_VALUE: 'Order Value',
  ORDERED_DATE: 'Ordered Date',
  ORDERS: 'Orders',
  OTHER_DETAILS: 'Other Details',

  PASSWORD: 'Password',
  PASSWORD_UPDATED_SUCCESSFULLY_LOGGING_OUT:
    'Password updated successfully, logging out...',
  PAYMENT: 'Payment',
  PAYMENT_TERMS: 'Payment Terms',
  PAYMENT_DUE_DATE: 'Payment Due Date',
  PHONE: 'Phone',

  PLEASE_ADD_QUANTITY_TO_SELECTED_PRODUCTS:
    'Please add quantity to selected products',
  PLEASE_ENTER_DESCRIPTION: 'Please enter Description',
  PLEASE_ENTER_SUBJECT: 'Please enter Subject',
  PLEASE_ENTER_VALID: 'Please enter valid ',
  PLEASE_ENTER_VALID_CREDINALS: 'Please enter valid credinals',

  PLEASE_SELECT_AT_LEAST_ONE_PRODUCT: 'Please select at least one product',
  PLEASE_SELECT_NAME: 'Please select Name',
  PLEASE_SELECT_PRODUCTS_TO_ADD_TO_CART:
    'Please select products to add to cart',
  PLEASE_UPLOAD: 'Please upload an image below 2 MB in size.',

  PO_NUMBER: 'PO Number',
  POSTAL_CODE: 'Zip/Postal Code',
  PREFERRED_SHIPPING_METHOD: 'Preferred Shipping Method',
  PRICE: 'Price',
  PRINT: 'Print',
  PRIORITY: 'Priority',
  PROCESS_ORDER_ID: 'Process Order ID',

  PRODUCT: 'Product',
  PRODUCT_DETAILS: 'Product Details',
  PRODUCT_FILTER: 'Product Filter',
  PRODUCT_ID: 'Product ID',
  PRODUCT_IMAGE: 'Product Image',
  PRODUCT_NAME: 'Product Name',
  PRODUCT_QUANTITY: 'Product Quantity',
  PRODUCT_STATUS: 'Product Status',
  PRODUCT_TYPE: 'Product Type',
  PRODUCTS: 'Products',
  PROFILE: 'Profile',
  PROFILE_SETTINGS: 'Profile and Settings',

  QR_: 'QR #',
  QR_CODE: 'QR code',
  QUANTITY: 'Quantity',
  QUANTITY_INVOICED: 'Quantity Invoiced',
  QUANTITY_ORDERED: 'Quantity Ordered',
  QUANTITY_PER_UNIT: 'Quantity per unit',
  QUANTITY_SHIPPED: 'Quantity Shipped',

  READ: 'Read',
  RECIPE_BUILDER: 'Recipe Builder',
  RECIPE_BUILDER_REPORT: 'Recipe Builder Report',
  RECIPE_BUILDER_TYPE: 'Recipe Builder Type',
  REMEMBER_ME: 'Remember me',
  REPLY: 'Reply',
  REPORTS: 'Reports',
  REQUESTED_DATE: 'Requested Date',
  REQUESTED_DELIVERY_DATE: 'Requested Delivery Date',
  RETAIL_PRICE: 'Retail Price',
  ROWS_PER_PAGE: 'Rows per page',

  SAVE: 'Save',
  SAVE_CHANGES: 'Save Changes',
  SAVE_TO_CART: 'Save to Cart',
  SEARCH: 'Search',
  SELECT: 'Select ',
  SELECT_CATEGORY: 'Select Category',
  SELECT_FROM: 'Select From',
  SELECT_LANGUAGE: 'Select Language',
  SELECT_RECIPE_BUILDER: 'Select Recipe Builder',
  SELECT_SUBCATEGORY: 'Select Subcategory',
  SELECT_TO: 'Select To',
  SEND: 'Send',
  SENT: 'Sent',
  SEND_ORDER: 'Send Order',
  SENDING_MESSAGES: 'Sending Messages...',
  SENDING_REPLIES: 'Sending Replies...',
  SET_AS_HIGH_PRIORITY: 'Set as High Priority',

  SHIP_TO: 'Ship To',
  SHIPPED_DATE: 'Shipped Date',
  SHIPPED_VIA: 'Shipped Via',
  SHIPPING: 'Shipping',
  SHIPPING_CALCULATION: 'Shipping Calculation',
  SHIPPING_CHARGE: 'Shipping Charge',
  SHIPPING_CHARGES: 'Shipping Charges',
  SHIPPING_DATE: 'Shipping Date',
  SHIPPING_DETAILS: 'Shipping Details',
  SHIPPING_FILTER: 'Shipping Filter',
  SHIPPING_FORM: 'Shipping Form',
  SHIPPING_ID: 'Shipping ID',
  SHIPPING_MEMOS: 'Shipping Memos',
  SHIPPING_METHOD: 'Shipping Method',
  SHIPPING_RATE: 'Shipping Rate',
  SIGN_IN: 'Sign In',
  SIGN_IN_PORTAL: 'Order-EZ Customer Sign-In Portal',
  SKU_IMAGE: 'Sku Image',
  SKU_IMAGEL: 'SKU #',
  SKU_NUMBER: 'SKU Number',
  SKU_ID: 'SKU ID',

  STATE: 'State/Province',
  STATUS: 'Status',
  STORE_ID: 'Customer ID',
  STORE_COST: 'Customer Cost',
  STORE_DETAILS: 'Customer Details',
  STORE_NOTE: 'Customer Note',
  STORE_NOTES: 'Customer Notes',
  STORE_PO: 'Customer PO',
  STORE_PO_NUMBER: 'Customer PO Number',
  STORE_PROFILE: 'Customer Profile',
  STORE_NAME: 'Customer Name',
  STORE_TAX1: 'Customer Tax1',
  STORE_TAX1_RATE: 'Customer Tax1 Rate',
  STORE_TAX2: 'Customer Tax2',
  STORE_TAX2_RATE: 'Customer Tax2 Rate',
  STORES: 'Customers',
  STATE_PROVINCE: 'Parent State/Province',

  SUB_CATEGORY: 'Subcategory',
  SUB_TOTAL: 'Subtotal',
  SUBCATEGORY: 'Subcategory',
  SUBJECT: 'Subject',
  SUBORDER_ID: 'SuborderID',

  SUPPLIER: 'Supplier',
  SUPPLIER_DETAILS: 'Supplier Details',
  SUPPLIER_NAME: 'Supplier Name',
  SUPPLIER_NOTES: 'Supplier Notes',
  SUPPLIER_VIA: 'Supplier Via',
  SUPPLIERS: 'Suppliers',

  TAG: 'Tag',
  TAXES: 'Taxes',
  TERMS: 'Terms',
  TO: 'To',
  TOTAL: 'Total',
  TOTAL_INVOICE: 'Total Invoice',
  TOTAL_PRICE: 'Total Price',
  TOTAL_ORDER_VALUE: 'Total Order Value',
  TOTAL_REQUIRED: 'Total Required',
  TO_BE_CONFIRMED: 'to be confirmed',

  UNIT: 'Unit',
  UNIT_OF_MEASURE: 'Units of Measure',
  UNIT_PRICE: 'Unit Price',
  UPDATE_CATEGORY_DETAILS: 'Updating category details...',
  UPDATING_SUBCATEGORIES_DETAILS: 'Updating Subcategory Details...',
  UPLOAD: 'Upload',
  UPLOADING_PROFILE_IMAGE: 'Uploading Profile Image...',
  URGENT: 'Urgent',
  USERNAME: 'Username',

  VERSION: 'Version',
  VIEW_ALL: 'view all',
  YES: 'Yes',
  VIEW_REPLY: 'View / Reply',
  NOTE_YOU_CAN_ENTER_UP_TO_500_CHARACTERS:
    'Note: You can enter up to 500 characters.',
  NO_SUPPLIER_NOTES_AVAILABLE: 'No Supplier Notes Available',
  SELECT_HIGH_PRIORITY: 'Select high priority',
  ENTER_STORE_PO_NUMBER: 'Enter Customer PO Number',
  ENTER_NOTE: 'Enter note',
  SELECT_SUB_CATEGORY: 'Select sub category',
  SELECT_PRODUCT: 'Select product',
  ENTER_STORE_COST: 'Enter Customer Cost',
  SELECT_COUNTRY: 'Select country',
  ENTER_COMPANY_NAME: 'Enter company name',
  SELECT_STATE: 'Select State/Province ',
  ENTER_CITY: 'Enter city',
  ENTER_COMPANY_ADDRESS: 'Enter Company Address',
  ENTER_POSTAL_CODE: 'Enter Zip/Postal Code ',
  ENTER_DESCRIPTION: 'Enter Description',
  ENTER_SUBJECT: 'Enter subject',
  SELECT_STATUS: 'Select status',
  SELECT_PAYMAENT_METHOD: 'Select payment method',
  SELECT_PAYMENT_TERMS: 'Select payment terms',
  SELECT_SETUP_FEE: 'Select setup fee',
  SELECT_SUBSCRIPTION_PACK: 'Select Subscription Pack',
  SELECT_SHIP_TO: 'Select ship to',
  SELECT_SHIPPING_CALCULATION: 'Select shipping calculations',
  SELECT_PRIORITY: 'Select priority',
  ENTER_YOUR_PASSWORD: 'Enter your Password',
  ENTER_YOUR_USERNAME: 'Enter your Username',
  YOUR_ORDER_SAVED: 'Your order below will be saved',
  CONFIRMATION: 'Confirmation',
  REACTIVATE_SUPPLIER_MESSAGE:
    'Are you sure you want to reactivate this supplier?',
  SPLIT: 'Split',
  CONFIRMED_QUANTITY: 'Confirmed Quantity',
  CART_PRESENT_MESSAGE: '*There is an order present in cart.',
  DELETE_PRODUCT_FROM_ORDER_CONFIRMATION:
    'Are you sure you want to delete this product from order?',
  LOGGED_IN_SUCCESSFULLY: 'Logged in successfully',
  ENTER_NAME: 'Enter Name',
  DELETE_MESSAGE: 'Delete message',
  VIEW: 'View',
  DOWNLOADING_SHIPING_DETAILS: 'Downloading shipping details',
  DOWNLOADING_INVOICE_DETAILS: 'Downloading invoice details',
  DOWNLOADING_ORDER_HISTORY_DETAILS: 'Downloading order history details',
  PLEASE_TYPE_DELETE: 'Please Type DELETE',
  ORDER_PRESENT_INCART:
    'There is an order present in the cart. Do you want to overwrite it',
  REQUESTED_DELIVERY_DATE_IS_REQUIRED: 'Requested Delivery date is required',
  THIS_PRODUCT_IS_ALREADY_ADDED: 'This Product is already added',
  THE_ORDER_IN_CART_AND_NEW_ORDER_ARE_SAME:
    'The order in cart and new order are same. Please select one of the below options.',
  CONTINUE_WITH_CART: 'Continue with cart',
  CREATE_NEW_ORDER: 'Create new order',
  CANCEL_DELETE: 'Cancel/Delete',

  UNAVAILABLE: 'Temp. Unavailable',
  PROCESSED: 'Processed',
  INPRODUCTION: 'InProduction',
  SHIPPED: 'Shipped',
  INVOICED: 'Invoiced',
  COMPLETE: 'Complete',
  CANCELLED: 'Cancelled',
  PACKED: 'Packed',
  BACKORDER: 'Backorder',
  REQUESTED_DELIVERY_DATE_MUST_IN_FUTURE:
    'Requested delivery date must be in the future',
  USA: 'USA',
  CANADA: 'Canada',

  // Canada State--
  ONTARIO: 'Ontario',
  QUEBEC: 'Quebec',
  NOVA_SCOTIA: 'Nova Scotia',
  NEW_BRUNSWICK: 'New Brunswick',
  MANITOBA: 'Manitoba',
  BRITISH_COLUMBIA: 'British Columbia',
  PRINCE_EDWARD_ISLAND: 'Prince Edward Island',
  SASKATCHEWAN: 'Saskatchewan',
  ALBERTA: 'Alberta',
  NEWFOUNDLAND_AND_LABRADOR: 'Newfoundland and Labrador',

  // USA State--
  ALABAMA: 'Alabama',
  ALASKA: 'Alaska',
  ARIZONA: 'Arizona',
  ARKANSAS: 'Arkansas',
  CALIFORNIA: 'California',
  COLORADO: 'Colorado',
  CONNECTICUT: 'Connecticut',
  DELAWARE: 'Delaware',
  DISTRICT_OF_COLUMBIA: 'District of Columbia',
  FLORIDA: 'Florida',
  GEORGIA: 'Georgia',
  HAWAII: 'Hawaii',
  IDAHO: 'Idaho',
  ILLINOIS: 'Illinois',
  INDIANA: 'Indiana',
  IOWA: 'Iowa',
  KANSAS: 'Kansas',
  KENTUCKY: 'Kentucky',
  LOUISIANA: 'Louisiana',
  MAINE: 'Maine',
  MARYLAND: 'Maryland',
  MASSACHUSETTS: 'Massachusetts',
  MICHIGAN: 'Michigan',
  MINNESOTA: 'Minnesota',
  MISSISSIPPI: 'Mississippi',
  MISSOURI: 'Missouri',
  MONTANA: 'Montana',
  NEBRASKA: 'Nebraska',
  NEVADA: 'Nevada',
  NEW_HAMPSHIRE: 'New Hampshire',
  NEW_JERSEY: 'New Jersey',
  NEW_MEXICO: 'New Mexico',
  NEW_YORK: 'New York',
  NORTH_CAROLINA: 'North Carolina',
  NORTH_DAKOTA: 'North Dakota',
  OHIO: 'Ohio',
  OKLAHOMA: 'Oklahoma',
  OREGON: 'Oregon',
  PENNSYLVANIA: 'Pennsylvania',
  RHODE_ISLAND: 'Rhode Island',
  SOUTH_CAROLINA: 'South Carolina',
  SOUTH_DAKOTA: 'South Dakota',
  TENNESSEE: 'Tennessee',
  TEXAS: 'Texas',
  UTAH: 'Utah',
  VERMONT: 'Vermont',
  VIRGINIA: 'Virginia',
  WASHINGTON: 'Washington',
  WEST_VIRGINIA: 'West Virginia',
  WISCONSIN: 'Wisconsin',
  WYOMING: 'Wyoming',

  STORE: 'Customer',
  PICKUP: 'Pickup',
  OTHER: 'Other',
  PERCENTAGE: 'Percentage',
  AMOUNT: 'Amount',
  MESSAGE_TO: 'Message To',
  ORDER_CREATED_SUCCESS: 'Order created successfully',
  ORDER_CREATION_FAILED: 'Failed to create Order',
  ORDER_CREATED_IN_CART: 'Order created in cart successfully',
  ORDER_CREATION_IN_CART_FAILED: 'Failed to create Order in Cart',
  SHIPPING_CHARGE_PERCENTAGE: 'Shipping charge Percentage',
  SHIPPING_CHARGE_AMOUNT: 'Shipping charge Amount',
  POWERED_BY_ORDER_EZ: 'Powered by Order-EZ.com',
  NO_SUPPLIER_NOTE_AVAILABLE: 'No Supplier note available',
  FETCHING_COUNTRIES: 'Fetching Countries',
  ADDING_NEW_SHIPPING_METHOD: 'Adding new shipping method...',
  NO_STORE_NOTES_AVAILABLE: 'No Customer Notes available',
  ADDING_NEW_TAX: 'Adding New Tax',
};
